export const environment = {
  name: "Test",
  production: false,
  // Initialize Firebase
  firebase: {
    apiKey: 'AIzaSyA82wZtzibww1O3hJvFesGSwmVzFVIl94o',
    authDomain: 'kpark-757a7.firebaseapp.com',
    databaseURL: 'https://de-sharpmind-nh-test.firebaseio.com/',
    projectId: 'kpark-757a7',
    storageBucket: 'de-sharpmind-nh-test',
    messagingSenderId: '903768140396'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts